"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const typography_1 = require("../../shared/typography");
const toggles_1 = require("../../shared/typography/toggles");
const Square = styled_components_1.default.div `
  align-items: center;
  border: 1px solid ${({ theme }) => theme.colors.silverBase};
  border-radius: ${({ theme }) => theme.utils.radius};
  display: flex;
  height: 1.5rem;
  justify-content: center;
  transition: ${({ theme }) => theme.utils.transition.default};
  width: 1.5rem;
`;
const InnerSquare = styled_components_1.default.div `
  background-color: ${({ theme }) => theme.colors.greyBase};
  border-radius: ${({ theme }) => theme.utils.radius};
  opacity: 0;
  height: 1rem;
  width: 1rem;
`;
const Checkbox = (0, react_1.forwardRef)(({ name, label, className, value, disabled, ...props }, ref) => {
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { className: className, disabled: disabled, children: [(0, jsx_runtime_1.jsx)("input", { ref: ref, type: "checkbox", name: name, ...props, value: value }, void 0), (0, jsx_runtime_1.jsxs)(toggles_1.TogglesLabel, { htmlFor: name, onClick: (e) => {
                    var _a, _b;
                    (_b = (_a = e.currentTarget.parentNode) === null || _a === void 0 ? void 0 : _a.querySelector("input")) === null || _b === void 0 ? void 0 : _b.click();
                }, children: [(0, jsx_runtime_1.jsx)(Square, { children: (0, jsx_runtime_1.jsx)(InnerSquare, {}, void 0) }, void 0), (0, jsx_runtime_1.jsx)(typography_1.H4, { children: label }, void 0)] }, void 0)] }, void 0));
});
exports.Checkbox = Checkbox;
const Wrapper = (0, styled_components_1.default)(toggles_1.TogglesWrapper) `
  margin: ${({ theme }) => `${theme.spacings.s} 0 ${theme.spacings.xs}`};

  ${({ disabled }) => (disabled ? "pointer-events: none" : "")};

  label {
    cursor: pointer;
  }

  label h4 {
    ${({ theme, disabled }) => disabled ? `color: ${theme.colors.greyLighten70}` : ""};
  }

  label > div {
    ${({ theme, disabled }) => disabled ? `border-color: ${theme.colors.silverBase}` : ""};
  }

  label > div > div {
    ${({ theme, disabled }) => disabled ? `background-color: ${theme.colors.silverBase}` : ""};
  }

  input:checked + label > h4 {
    ${({ theme, disabled }) => disabled ? `color: ${theme.colors.greyLighten70}` : ""};
  }
`;
//# sourceMappingURL=Checkbox.js.map